import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CarouselModule } from 'primeng/carousel';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { RatingModule } from 'primeng/rating';
import { ToastModule } from 'primeng/toast';
import { TranslateModule } from '@ngx-translate/core';
import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';
import { ClipboardModule } from 'ngx-clipboard';

const THIRDMODULES = [
    AutoCompleteModule,
    ButtonModule,
    CarouselModule,
    DropdownModule,
    GalleryModule,
    InputTextModule,
    LightboxModule,
    MenuModule,
    RatingModule,
    TranslateModule,
    ToastModule,
    ClipboardModule,
];

import { AvatarComponent } from './components/avatar/avatar.component';
import { BlankComponent } from './components/blank/blank.component';
import { EmptyComponent } from './components/empty/empty.component';
import { LoadingComponent } from './components/loading/loading.component';

const COMPONENTS = [AvatarComponent, BlankComponent, EmptyComponent, LoadingComponent];
const COMPONENTS_NOROUNT = [];

import { AppShellNoRenderDirective, FreeDraggingDirective, FreeDraggingHandleDirective } from './directives';

const DIRECTIVES = [AppShellNoRenderDirective, FreeDraggingDirective, FreeDraggingHandleDirective];

import { CountryPipe, CoffeeStoryLinkPipe, OutletLinkPipe, PhonePipe } from './pipes';

const PIPES = [CountryPipe, CoffeeStoryLinkPipe, OutletLinkPipe, PhonePipe];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        // third libs
        ...THIRDMODULES,
    ],
    declarations: [
        // your components
        ...COMPONENTS,
        ...COMPONENTS_NOROUNT,
        ...DIRECTIVES,
        ...PIPES,
    ],
    entryComponents: COMPONENTS_NOROUNT,
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        // third libs
        ...THIRDMODULES,
        // your components
        ...COMPONENTS,
        ...DIRECTIVES,
        ...PIPES,
    ],
    providers: [],
})
export class SharedModule {}
